import React from 'react'
import InstagramIcon from '../assets/icons/instagram.svg'
import FacebookSocialIcon from '../assets/icons/facebook.svg'
import FacebookAuthIcon from '../assets/auth/facebook.svg'
import LinkedInIcon from '../assets/icons/linkedin.svg'
import XIcon from '../assets/icons/x.svg'
import GoogleIcon from '../assets/auth/google.svg'
import AppleIcon from '../assets/auth/apple.svg'
import ChromeIcon from '../assets/icons/chrome.svg'
import FirefoxIcon from '../assets/icons/firefox.svg'
import EdgeIcon from '../assets/icons/edge.svg'

const icons = {
  instagram: InstagramIcon,
  facebook: FacebookSocialIcon,
  'facebook-social': FacebookAuthIcon,
  linkedin: LinkedInIcon,
  x: XIcon,
  google: GoogleIcon,
  apple: AppleIcon,
  chrome: ChromeIcon,
  firefox: FirefoxIcon,
  edge: EdgeIcon,
} as const

export type IconType = keyof typeof icons

interface IconProps extends React.SVGProps<SVGSVGElement> {
  type: IconType
  size?: number
}

const Icon: React.FC<IconProps> = ({
  type,
  size = 20,
  width,
  height,
  className,
  style,
}) => {
  const IconComponent = icons[type]

  if (!IconComponent) {
    return null
  }

  const iconSize = width ?? height ?? size
  const iconStyle = {
    width: iconSize,
    height: iconSize,
    ...style,
  }

  // SVGR with icon: true generates components that don't accept standard SVG props
  // We need to use type assertion here
  const SVGComponent = IconComponent as unknown as React.FC<{ className?: string; style?: React.CSSProperties }>

  return (
    <SVGComponent
      className={className}
      style={iconStyle}
    />
  )
}

export default Icon
